/**
 * `window.location.replace` の薄いラッパー。
 *
 * jsdom では `window.location` を差し替えられずテストから呼び出しを検証できないため、
 * モジュールとして切り出し `vi.mock` で差し替えられるようにしている。
 * ブラウザ履歴に残さない遷移（ログアウト後・認証やり直し）で使う。
 */
export const replaceLocation = (url: string) => {
  window.location.replace(url)
}
